/**
 * OneTrust Performance/Analytics cookie category ID
 * C0002 is the standard category for analytics cookies
 */
const ANALYTICS_CATEGORY_ID = 'C0002';

const ONE_TRUST_POLL_INTERVAL_MS = 100;

const ONE_TRUST_READY_TIMEOUT_MS = 5000;

function getActiveGroups(): string | undefined {
  return (globalThis as typeof globalThis & { OnetrustActiveGroups?: string })
    .OnetrustActiveGroups;
}

/**
 * Check if analytics cookies are currently consented
 * by examining the OnetrustActiveGroups global variable
 */
export function hasAnalyticsConsent(): boolean | null {
  const activeGroups = getActiveGroups();
  return activeGroups === undefined
    ? null
    : activeGroups.includes(ANALYTICS_CATEGORY_ID);
}

/**
 * Subscribe to OneTrust consent changes.
 *
 * Notifies on every `OneTrustGroupsUpdated` event, and once more when OneTrust
 * finishes loading — it publishes its initial state without emitting an event.
 *
 * @param onChange - Called whenever the active consent groups may have changed
 * @returns Unsubscribe function
 */
export function subscribeToConsentChanges(onChange: () => void): () => void {
  globalThis.addEventListener('OneTrustGroupsUpdated', onChange);

  const readyPoll = setInterval(() => {
    if (getActiveGroups() !== undefined) {
      clearInterval(readyPoll);
      clearTimeout(readyTimeout);
      onChange();
    }
  }, ONE_TRUST_POLL_INTERVAL_MS);

  const readyTimeout = setTimeout(() => {
    clearInterval(readyPoll);
  }, ONE_TRUST_READY_TIMEOUT_MS);

  return () => {
    globalThis.removeEventListener('OneTrustGroupsUpdated', onChange);
    clearInterval(readyPoll);
    clearTimeout(readyTimeout);
  };
}
